import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { UsereditorComponent } from '../usereditor/usereditor.component';
import { ApiService } from '../../services/api.service';
import { User } from '../../interfaces/interfaces';
import { filter } from 'rxjs/operators';
import { SimpleTableComponent } from '../../generals/Components';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
  providers: [DialogService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UsersComponent extends SimpleTableComponent<User> {

  constructor(
    private apiServiceRef: ApiService,
    private dialogService: DialogService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'users';
  }

  showUserEditorModal(user: User|null = null): void {
    this.dialogService.open(UsereditorComponent, {
      header: user !== null ? 'Felhasználó szerkesztése - ' + user.fullname : 'Felhasználó hozzáadása',
      data: {
        userId: user !== null ? user.id : null
      }
    }).onClose.pipe(filter(v => v === true)).subscribe(() => {
      this.refreshTable();
    });
  }

}
